import { useEffect, useRef } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useReferAndEarnPopup, ReferAndEarnSource } from 'hooks/useReferAndEarnPopup';
import { RootState } from 'store';
import { FeatureName, ScriptStatus } from 'types/featureFlags';
import { REFER_AND_EARN_QUERY_PARAM } from 'scenes/referAndEarn';

export const useReferAndEarnQueryParam = () => {
    const location = useLocation();
    const history = useHistory();
    const userInfo = useSelector((state: RootState) => state.user?.userInfo);
    const loggedIn = !!userInfo?.email;
    const proLineStatus = useSelector((state: RootState) => state.scriptStatus?.[FeatureName.ProLine]);
    const { openPopup } = useReferAndEarnPopup();
    const openedRef = useRef(false);

    useEffect(() => {
        // Check if query param is present
        const searchParams = new URLSearchParams(location.search);
        const hasReferAndEarnParam = searchParams.get(REFER_AND_EARN_QUERY_PARAM) === 'true';

        // Only proceed if logged in and query param is present
        if (!loggedIn || !hasReferAndEarnParam) {
            return;
        }

        // Wait for ProLine script to be loaded by DynamicScripts
        if (openedRef.current) return;

        if (proLineStatus === ScriptStatus.Completed || proLineStatus === ScriptStatus.Failed) {
            // Track as LINK source (deep link navigation)
            openPopup(ReferAndEarnSource.LINK);
            openedRef.current = true;

            // Remove query param from URL
            searchParams.delete(REFER_AND_EARN_QUERY_PARAM);
            const newSearch = searchParams.toString();
            history.replace({ search: newSearch ? `?${newSearch}` : '' });
        }
    }, [location.search, location.key, proLineStatus, openPopup, loggedIn, history]);
};
